import React from 'react';
import '../styles/PrototyperPage.css';

const PrototyperPage = () => {
  return (
    <div className="prototyper-page">
      <div className="wip-container">
        <div className="wip-header">
          <h2>AI Prototyper</h2>
          <div className="wip-badge">Coming Soon</div>
        </div>
        
        <div className="wip-content">
          <div className="prototype-preview">
            <div className="conversation-header">
              <div className="conversation-title">
                <span className="title-icon">💡</span>
                <span>New Prototype Session</span>
              </div>
              <div className="conversation-actions">
                <button className="action-icon" disabled>
                  <span>📋</span>
                </button>
                <button className="action-icon" disabled>
                  <span>⚙️</span>
                </button>
              </div>
            </div>
            
            <div className="conversation-container">
              <div className="conversation-messages">
                <div className="message system">
                  <div className="message-content">
                    <p>Welcome to the AI Prototyper. Describe your idea, and I'll help you build it iteratively through conversation.</p>
                  </div>
                </div>
                
                <div className="message user">
                  <div className="message-avatar">U</div>
                  <div className="message-content">
                    <p>I need a recommendation system for books based on user preferences.</p>
                  </div>
                </div>
                
                <div className="message ai">
                  <div className="message-avatar">AI</div>
                  <div className="message-content">
                    <p>I'll help you prototype a book recommendation system. Let's start with the core components:</p>
                    <div className="prototype-block">
                      <div className="block-header">
                        <span className="block-type">Component Structure</span>
                        <span className="block-version">v1</span>
                      </div>
                      <pre className="code-block">
{`BookRecommendationSystem
├── UserPreferenceCollector
│   ├── GenreSelector
│   ├── AuthorPreferences
│   └── ReadingHistoryImport
├── RecommendationEngine
│   ├── ContentBasedFiltering
│   └── CollaborativeFiltering
└── RecommendationDisplay
    ├── BookList
    ├── DetailView
    └── SaveToReadingList`}
                      </pre>
                    </div>
                    <p>How does this initial structure look? We can refine it based on your feedback.</p>
                  </div>
                </div>
                
                <div className="message user">
                  <div className="message-avatar">U</div>
                  <div className="message-content">
                    <p>I like it, but can we add a feature for mood-based recommendations?</p>
                  </div>
                </div>
                
                <div className="message ai typing">
                  <div className="message-avatar">AI</div>
                  <div className="message-content">
                    <div className="typing-indicator">
                      <span className="dot"></span>
                      <span className="dot"></span>
                      <span className="dot"></span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="conversation-input">
                <textarea 
                  placeholder="Continue the conversation to evolve your prototype..." 
                  disabled
                ></textarea>
                <button className="send-button" disabled>
                  <span>↑</span>
                </button>
              </div>
            </div>
          </div>
          
          <div className="wip-info">
            <h3>AI Prototyper Features</h3>
            <ul>
              <li>Text-based prototype development through conversation</li>
              <li>Iterative refinement based on your feedback</li>
              <li>Component structure visualization</li>
              <li>Code snippet generation</li>
              <li>User flow mapping</li>
              <li>Export to documentation</li>
            </ul>
            <div className="progress-bar">
              <div className="progress" style={{ width: '35%' }}></div>
            </div>
            <p className="progress-text">Development: 35% Complete</p>
            
            <div className="prototype-evolution">
              <h4>How It Works</h4>
              <div className="evolution-steps">
                <div className="evolution-step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h5>Describe Your Idea</h5>
                    <p>Start with a simple description of what you want to build</p>
                  </div>
                </div>
                <div className="evolution-step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h5>AI Generates Prototype</h5>
                    <p>Get an initial structure, components, and relationships</p>
                  </div>
                </div>
                <div className="evolution-step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h5>Provide Feedback</h5>
                    <p>Suggest changes, additions, or refinements</p>
                  </div>
                </div>
                <div className="evolution-step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h5>Evolve Your Prototype</h5>
                    <p>Watch your idea transform through conversation</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrototyperPage;
